import { fleetImages } from "./fleetImages";

const pendingSpecs = {
  fleetSize: "Por confirmar",
  maxCapacity: "Por confirmar",
  autonomy: "Por confirmar",
  dimensions: {
    long: "Por confirmar",
    width: "Por confirmar",
    high: "Por confirmar",
    weight: "Por confirmar",
  },
};

export const getFleetTimelineLabel = (plane) => {
  if (plane?.nickname) {
    return `${plane.model} / ${plane.nickname}`;
  }
  return plane?.model || "";
};

export const getFleetDisplayName = (plane) =>
  plane?.nickname || plane?.fullModel || plane?.model || "avión";

export const fleetData = [
  {
    id: "erj-190",
    model: "ERJ-190",
    fullModel: "EMBRAER 190",
    category: "Corto Alcance",
    fleetSize: "47 Aviones",
    maxCapacity: "900KG",
    autonomy: "4,537 km",
    dimensions: {
      long: "120 cm",
      width: "101 cm",
      high: "70 cm",
      weight: "70-80 kg",
    },
    image: fleetImages["erj-190"],
    secondaryImages: [fleetImages["erj-190-05"]],
  },
  {
    id: "b737-700",
    model: "B737-700",
    fullModel: "BOEING 737-700",
    category: "Mediano Alcance",
    fleetSize: "11 Aviones",
    maxCapacity: "1,200 kg",
    autonomy: "6,750 km",
    dimensions: {
      long: "109 cm",
      width: "121 cm",
      high: "78 cm",
      weight: "180 kg",
    },
    image: fleetImages["b737-700"],
  },
  {
    id: "b737-800",
    model: "B737F-800",
    fullModel: "BOEING 737-800",
    category: "Mediano Alcance",
    fleetSize: "36 Aviones",
    maxCapacity: "1,500 kg",
    autonomy: "5,765 km",
    dimensions: {
      long: "124 cm",
      width: "121 cm",
      high: "81 cm",
      weight: "180 kg",
    },
    image: fleetImages["b737-800"],
  },
  {
    id: "b737-max-kukulcan",
    model: "B737 MAX",
    nickname: "Kukulcán",
    fullModel: "KUKULCÁN",
    category: "Mediano Alcance",
    image: fleetImages["b737-max-kukulcan"],
    secondaryImages: [fleetImages["b737-max-kukulcan-05"]],
    ...pendingSpecs,
  },
  {
    id: "b787-8",
    model: "B787-8",
    fullModel: "BOEING 787-8",
    category: "Largo Alcance",
    fleetSize: "9 Aviones",
    maxCapacity: "20,000 kg",
    autonomy: "14,200 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "70-80 kg",
    },
    image: fleetImages["b787-8"],
    secondaryImages: [fleetImages["b787-8-05"]],
  },
  {
    id: "b787-9",
    model: "B787-9",
    nickname: "Quetzalcóatl",
    fullModel: "BOEING 787-9",
    category: "Largo Alcance",
    fleetSize: "10 Aviones",
    maxCapacity: "23,000 kg",
    autonomy: "14,800 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "180 kg",
    },
    image: fleetImages["b787-9"],
    secondaryImages: [fleetImages["b787-9-quetzalcoatl-05"]],
  },
];

export const getPlaneImageViews = (plane) => {
  const planeName = getFleetDisplayName(plane);
  const views = [];

  if (plane?.image) {
    views.push({
      src: plane.image,
      label: `Vista principal de ${planeName}`,
    });
  }

  (plane?.secondaryImages || []).forEach((src, index) => {
    views.push({
      src,
      label: `Vista alternativa ${index + 1} de ${planeName}`,
    });
  });

  return views;
};
